import { Component, Input, Output, OnInit, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';
import { NoiseCustomLineService } from './noise-custom-line.service'
import * as _ from 'lodash'
import { NoiseCustomLineData } from './noise-custom-line-interface';
type tool = 'calculate' | 'brush' | 'brushEnlarge' | 'brushRestore' ;

@Component({
  selector: 'bcac-noise-custom-line',
  templateUrl: './noise-custom-line.component.html',
  styleUrls: ['./noise-custom-line.component.scss']
})

export class NoiseCustomLineComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService,
    private service: NoiseCustomLineService,
    private cdr: ChangeDetectorRef,
  ) { }

  chartTitle = {
    show: true,
    label: "图表标题"
  };

  initOpts = this.chartOptionService.getInitOpts();

  // 布局设置
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = '';

  // eachrt图表元素
  chartBackgroundColor: string = "#fff";
  chartColors: string[] = this.chartOptionService.getChartColors("default");
  chartTitles = this.chartOptionService.getChartTitle();
  chartLegend = this.service.getChartLegend();
  chartGrid: EChartOption.Grid = this.commonService.changeFontSize().interval;
  chartxAxis = this.service.getChartxAxis();
  chartyAxis = this.service.getChartyAxis();
  chartSeries: EChartOption.Series = [];
  chartTooltip = this.service.getDefaultTooltip();
  chartToolbox = this.service.getChartToolbox();
  chartBrush = this.service.getChartBrush();

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    color: this.chartColors,
    title: this.chartTitles,
    tooltip: this.chartTooltip,
    legend: this.chartLegend,
    grid: this.chartGrid,
    xAxis: this.chartxAxis,
    yAxis: this.chartyAxis,
    series: this.chartSeries,
    toolbox: this.chartToolbox,
    brush: this.chartBrush
  };

  bcacIsDarkMode: boolean = false
  //接口区
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    const isdarkMode: boolean = typeof (darkMode) == "string"
    ? darkMode?JSON.parse(darkMode):true
    : darkMode;
    if (isdarkMode) {
      this.service.changeChartTitleDark(this, darkMode);
      this.service.chartBackgroundColorDarkMode(this.chartOption);
      this.service.xAxisDarkMode(this.chartxAxis);
      this.service.yAxisDarkMode(this.chartyAxis);
      this.service.colorsDarkMode(this.chartColors);
      this.service.legendDarkMode(this.chartLegend);
      this.service.seriesDarkMode(this.chartSeries);
    }
    this.bcacIsDarkMode = isdarkMode
  }

  @Input()
  set bcacSmallMode(smallMode: boolean | string) {
    const issmallMode: boolean = typeof (smallMode) == "string"
      ? JSON.parse(smallMode)
      : smallMode;
    if (issmallMode) {
      this.service.setSmallModeGrid(this.chartGrid);
      this.service.setSmallModePadding(this)
    }
  }

  _bcacLegendShow: boolean = true  //是否显示lengend,即使legendPosition = "top"时也显示
  @Input()
  set bcacLegendShow(show: boolean) {
    this._bcacLegendShow = show;
  }

  legendPosition = "top";
  @Input()
  set bcacLegendPosition(legendPosition: string) {
    this.legendPosition = legendPosition;
    this.service.setLegendPosition(this.chartGrid, this.chartLegend, legendPosition, this._bcacLegendShow);
  }

  //todo  关闭标题栏
  @Input()
  set bcacTitleSwitch(titleSwitch: boolean | string) {
    this.chartTitle.show = typeof (titleSwitch) == "string"
      ? JSON.parse(titleSwitch)
      : titleSwitch;
  }

  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }

  @Input()
  set bcacXaxisName(xAxisname: string) {
    this.chartOption.xAxis[0].name = xAxisname
  }

  @Input()
  set bcacYaxisName(yAxisNames: string) {
    this.chartOption.yAxis[0].name = yAxisNames
  }

  @Input()
  set bcacYnameGap(yNameGap: number) {
    this.service.setYnameGap(this.chartyAxis, yNameGap);
  }

  @Input()
  set bcacColors(colorList: string[]) {
    this.service.chartColorsChange(this.chartColors, colorList);
  }

  //todo x轴刻度标签旋转
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: number) {
    this.chartOption.xAxis[0].axisLabel.rotate = xAxisLabelRotate;
  }
  //todo  y轴刻度标签旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: number) {
    this.chartOption.yAxis[0].axisLabel.rotate = yAxisLabelRotate;
  }
  //todo tooltip显示格式化
  @Input()
  set bcacTooltipFormatter(value: any) {
    this.chartOption.tooltip = this.service.setTooltipFormat(value);
  }

  toolboxList = []
  @Input()
  set bcacToolboxList(data:tool[]) {
    if(data){
      this.toolboxList = data
    }
  }

  //todo  图数据
  receiveChartSeriesData  //接收的chart数据
  legendDataList;
  @Input()
  set bcacChartData(chartData: NoiseCustomLineData) {
    if (chartData
      && chartData.xAxisDatas
      && Array.isArray(chartData.xAxisDatas)
      && chartData.seriesDatas
      && Array.isArray(chartData.seriesDatas)
    ) {
      this.chartOption.xAxis[0].data = chartData.xAxisDatas
      if (chartData.xFormatter) {
        this.chartOption.xAxis[0].axisLabel.formatter = chartData.xFormatter
      }
      this.receiveChartSeriesData = []
      let ydata = []
      this.legendDataList = []
      for (const item of chartData.seriesDatas) {
        if (item.customRender) {
          this.receiveChartSeriesData.push({
            name: item.categoryName,
            nameId: item.nameId,
            type: 'custom',
            renderItem: item.customRender,
            smooth: true,
            "z": 10,
            data: item.data,
          })
          if (item.isChecked) {
            ydata.push({
              name: item.categoryName,
              nameId: item.nameId,
              type: 'custom',
              renderItem: item.customRender,
              smooth: true,
              "z": 10,
              data: item.data,
            })
          }
        } else {
          this.receiveChartSeriesData.push({
            name: item.categoryName,
            nameId: item.nameId,
            data: item.data,
            type: 'line',
            symbol: 'circle',//实心
            symbolSize: 2,
            smooth: true,
          })
          if (item.isChecked) {
            ydata.push({
              name: item.categoryName,
              nameId: item.nameId,
              data: item.data,
              type: 'line',
              symbol: 'circle',//实心
              symbolSize: 2,
              smooth: true,
            })
          }
        }

        this.legendDataList.push({
          label: item.categoryName,
          value: item.nameId,
          checked: item.isChecked
        })
      }
      this.legendDataList = this.remove_duplicate(this.legendDataList)
      this.chartOption.series = ydata
    }
  }

  //todo 图例改变
  @Output() bcacLegendCheckedChange: EventEmitter<any> = new EventEmitter<any>()  //lenged选中值
  legendChange(e) {
    let checkedLengend = []
    e.map((item) => {
      if (item.checked) {
        checkedLengend.push(item.value)
      }
    })
    let ydata = []
    for (const item of this.receiveChartSeriesData) {
      if (checkedLengend.includes(item.nameId)) {
        ydata.push(item)
      }
    }
    if (this.optionInstance) {
      this.chartOption.series = ydata
      this.optionInstance.setOption(this.chartOption, true);
    }
    this.bcacLegendCheckedChange.emit(e)
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    if (!_.isNil(value)) {
      this.dataSourceSelectData = value;
    }

  }

  intervalDatas = [];
  @Input()
  set bcacInterValDatas(value: any[]) {
    if (!_.isNil(value)) {
      this.intervalDatas = value;
    }
  }


  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Output() bcacDataSourceChange = new EventEmitter<any>(); //数据源
  @Output() bcacDataSourceSelectEmit = new EventEmitter<any>(); //数据源
  dataSourceChange(e: any) {
    this.bcacDataSourceChange.emit(e);
    this.bcacDataSourceSelectEmit.emit(e);
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>(); //获取实例
  optionInstance;
  onOptionInit(ec) {
    this.optionInstance = ec;
    this.bcacGetChartInstance.emit(ec)
    this.brushMonitor(); //todo
  }

  updateOption() {
    if (this.optionInstance) {
      this.optionInstance.setOption(this.chartOption, true);
    }
  }

  //todo 去重
  remove_duplicate(oldlist) {
    let newlist = {};
    return oldlist.reduce((p, c) => {
      newlist[c.value] ? '' : newlist[c.value] = true && p.push(c);
      return p
    }, []);
  }



  // X轴刻度间隔
  axisScaleChange(e: number) {
    if (this.optionInstance) {
      let option = this.optionInstance.getOption()
      option.xAxis[0].axisLabel.interval = e
      this.optionInstance.setOption(option, true)
    }
  }

  ngOnInit() {
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.optionInstance, this.chartOption);
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateOption()
  }


  //todo 框选
  brush(e) {
    this.service.brushTrigger(e, this.optionInstance)
    if (e.type == 'brush_clear'){
      this.isClearActive = false
    }
  }

  @Output() bcacBrushSelected: EventEmitter<any> = new EventEmitter<any>() //框选事件
  isClearActive:boolean = false //是否可清除
  brushMonitor() {
    if (this.optionInstance) {
      this.optionInstance.on('brushEnd', (value) => {
        if (value.areas) {
          this.isClearActive = true
          this.bcacBrushSelected.emit(value)
        }
        this.cdr.detectChanges();
      });
    }
  }

  @Output() bcacBrushEnlarge: EventEmitter<any> = new EventEmitter<any>()
  brushEnlarge(e) {
    this.bcacBrushEnlarge.emit(e.type)
  }


  @Output() bcacBrushRestore: EventEmitter<any> = new EventEmitter<any>()
  brushRestore(e) {
    this.bcacBrushRestore.emit(e.type)
  }

  @Output() bcacBrushCalculation: EventEmitter<any> = new EventEmitter<any>()
  calculate(e){
    this.bcacBrushCalculation.emit(e.type)
  }

}
